/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInner } from './SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInner';
import {
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInnerFromJSON,
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInnerFromJSONTyped,
    SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInnerToJSON,
} from './SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInner';

/**
 * 
 * @export
 * @interface SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf
 */
export interface SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf {
    /**
     * 
     * @type {Array<SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInner>}
     * @memberof SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf
     */
    form_instances?: Array<SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInner>;
}

/**
 * Check if a given object implements the SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf interface.
 */
export function instanceOfSupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFromJSON(json: any): SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf {
    return SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFromJSONTyped(json, false);
}

export function SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'form_instances': !exists(json, 'form_instances') ? undefined : ((json['form_instances'] as Array<any>).map(SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInnerFromJSON)),
    };
}

export function SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfToJSON(value?: SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'form_instances': value.form_instances === undefined ? undefined : ((value.form_instances as Array<any>).map(SupplementalGetInternalFormsByQuoteIdsResponseResultsInnerAllOfFormInstancesInnerToJSON)),
    };
}

